export default class ConversationalAnalyticsGateway {
  constructor(backend) {
    this.backend = backend;
  }

  init({ orgId }) {
    this.orgId = orgId;
  }

  get _httpClient() {
    return this.backend.axios();
  }

  chat({ question, analyticsConversationId, timezone }) {
    const payload = { question };
    if (analyticsConversationId) {
      payload.analyticsConversationId = analyticsConversationId;
    }
    if (timezone) {
      payload.timezone = timezone;
    }

    return this._httpClient
      .post(`/api/reporting/v1/orgs/${this.orgId}/conversational-analytics/messages`, payload, {
        timeout: 120000,
      })
      .then(res => res.data);
  }

  // Demo orgs don't have a real reporting backend, so route to glados's fake
  // Insights Agent chat instead. It resolves the org from the session itself,
  // so no orgId is needed in the request.
  chatDemo({ question, history }) {
    return this._httpClient
      .post('/sidekick/api/conversational-analytics', { question, history }, { timeout: 120000 })
      .then(res => ({ answer: res.data.response }));
  }
}
